import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PremiumUpgradePrompt = ({ 
  exerciseCount = 0, 
  maxFreeExercises = 2,
  className = '' 
}) => {
  const remainingExercises = Math.max(0, maxFreeExercises - exerciseCount);
  const isAtLimit = exerciseCount >= maxFreeExercises;

  if (!isAtLimit && remainingExercises > 0) {
    return (
      <div className={`bg-warning/5 border border-warning/20 rounded-lg p-4 ${className}`}>
        <div className="flex items-start space-x-3">
          <div className="w-8 h-8 bg-warning/10 rounded-full flex items-center justify-center flex-shrink-0">
            <Icon name="Info" size={16} className="text-warning" />
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-medium text-foreground mb-1">
              Free Tier Limit
            </h3>
            <p className="text-sm text-muted-foreground mb-3">
              You have {remainingExercises} exercise{remainingExercises !== 1 ? 's' : ''} remaining this week. 
              Upgrade to Premium for unlimited exercises and advanced features.
            </p>
            <Button
              variant="outline"
              size="sm"
              iconName="Crown"
              iconPosition="left"
              asChild
            >
              <Link to="/subscription-management">Learn More</Link>
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`bg-gradient-to-br from-warning/10 to-primary/10 border border-warning/30 rounded-lg p-6 text-center ${className}`}>
      <div className="w-16 h-16 bg-warning/20 rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon name="Crown" size={32} className="text-warning" />
      </div>
      
      <h3 className="text-lg font-semibold text-foreground mb-2">
        Weekly Exercise Limit Reached
      </h3>
      
      <p className="text-sm text-muted-foreground mb-4 max-w-md mx-auto">
        You've completed your {maxFreeExercises} free exercises this week! 
        Upgrade to Premium to unlock unlimited exercises, advanced analytics, 
        and personalized career development plans.
      </p>

      <div className="space-y-3 mb-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
          <div className="flex items-center space-x-2 text-muted-foreground">
            <Icon name="Check" size={16} className="text-success" />
            <span>Unlimited exercises</span>
          </div>
          <div className="flex items-center space-x-2 text-muted-foreground">
            <Icon name="Check" size={16} className="text-success" />
            <span>AI-powered plans</span>
          </div>
          <div className="flex items-center space-x-2 text-muted-foreground">
            <Icon name="Check" size={16} className="text-success" />
            <span>Advanced analytics</span>
          </div>
          <div className="flex items-center space-x-2 text-muted-foreground">
            <Icon name="Check" size={16} className="text-success" />
            <span>Export capabilities</span>
          </div>
        </div>
      </div>

      <div className="space-y-2">
        <Button
          variant="default"
          size="default"
          iconName="Crown"
          iconPosition="left"
          asChild
        >
          <Link to="/subscription-management">Upgrade to Premium</Link>
        </Button>
        
        <div className="text-xs text-muted-foreground">
          ✓ 30-day money-back guarantee
        </div>
      </div>
    </div>
  );
};

export default PremiumUpgradePrompt;